/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { VISUAL_HEADER_TYPES } from 'modules/dashboard/constants';

const mapper = {
  PVH_Daily: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.DOUBLE,
    transformColumns: true,
    metrics: {
      Room_Nights: {
        subColumns: ['A Actls', 'B Actls', '% Chg', 'A Fcsts', 'B Fcsts'],
      },
      Revenue: {
        subColumns: ['A Actls', 'B Actls', '% Chg', 'A Fcsts', 'B Fcsts'],
      },
      ADR: {
        subColumns: ['A Actls', 'B Actls', '% Chg'],
      },
      Cancellation_Count: {
        subColumns: ['A Actls', 'B Actls', '% Chg'],
      },
    },
  },
  PVH_Lag_Aligned: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.DOUBLE,
    transformColumns: true,
    metrics: {
      Room_Nights: {
        subColumns: ['A Actls', 'B Actls', '% Chg', 'A Fcsts', 'B Fcsts'],
      },
      Revenue: {
        subColumns: ['A Actls', 'B Actls', '% Chg', 'A Fcsts', 'B Fcsts'],
      },
      ADR: {
        subColumns: ['A Actls', 'B Actls', '% Chg'],
      },
      Cancellation_Count: {
        subColumns: ['A Actls', 'B Actls', '% Chg'],
      },
    },
  },
  PVH_Cumulative: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.DOUBLE,
    transformColumns: true,
    metrics: {
      Room_Nights: {
        subColumns: ['A Actls', 'B Actls', '% Chg', 'A Fcsts', 'B Fcsts'],
      },
      Revenue: {
        subColumns: ['A Actls', 'B Actls', '% Chg', 'A Fcsts', 'B Fcsts'],
      },
      ADR: {
        subColumns: ['A Actls', 'B Actls', '% Chg'],
      },
      Cancellation_Count: {
        subColumns: ['A Actls', 'B Actls', '% Chg'],
      },
    },
  },
  PVH_Cumulative_Lag_Aligned: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.DOUBLE,
    transformColumns: true,
    metrics: {
      Room_Nights: {
        subColumns: ['A Actls', 'B Actls', '% Chg', 'A Fcsts', 'B Fcsts'],
      },
      Revenue: {
        subColumns: ['A Actls', 'B Actls', '% Chg', 'A Fcsts', 'B Fcsts'],
      },
      ADR: {
        subColumns: ['A Actls', 'B Actls', '% Chg'],
      },
      Cancellation_Count: {
        subColumns: ['A Actls', 'B Actls', '% Chg'],
      },
    },
  },
  PVT_Cumulative_Lag_Aligned: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.DOUBLE,
    transformColumns: true,
    metrics: {
      Room_Nights: {
        subColumns: ['Select.', 'Compar.', '% Chg', 'Forecast'],
      },
      Revenue: {
        subColumns: ['Select.', 'Compar.', '% Chg', 'Forecast'],
      },
      ADR: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
      Cancellation_Count: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
    },
  },
  PVT_Percentage: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.DOUBLE,
    metrics: {
      Room_Nights: {
        subColumns: ['Selection', 'Comparison', 'Forecast'],
      },
      Revenue: {
        subColumns: ['Selection', 'Comparison', 'Forecast'],
      },
      ADR: {
        subColumns: ['Selection', 'Comparison'],
      },
    },
  },
  PVT_Lag_Aligned: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.DOUBLE,
    transformColumns: true,
    metrics: {
      Room_Nights: {
        subColumns: ['Selection', 'Comparison', '% Chg', 'Forecast'],
      },
      Revenue: {
        subColumns: ['Selection', 'Comparison', '% Chg', 'Forecast'],
      },
      ADR: {
        subColumns: ['Selection', 'Comparison', '% Chg'],
      },
      Cancellation_Count: {
        subColumns: ['Selection', 'Comparison', '% Chg'],
      },
    },
  },

  PVS_Daily: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.DOUBLE_2,
  },
  PVS_Cumulative: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.DOUBLE_2,
  },
  PVS_Cumulative_Lag_Aligned: {
    groupBy: 'Lags',
    headerType: VISUAL_HEADER_TYPES.DOUBLE_2,
  },

  PVS_Lag_Aligned: {
    groupBy: 'Lags',
    headerType: VISUAL_HEADER_TYPES.DOUBLE_2,
  },
  PVT_Cumulative: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.DOUBLE,
    metrics: {
      Room_Nights: {
        subColumns: ['Select.', 'Compar.', '% Chg', 'Forecast'],
      },
      Revenue: {
        subColumns: ['Select.', 'Compar.', '% Chg', 'Forecast'],
      },
      ADR: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
      Cancellation_Count: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
    },
  },
  PVT_Daily: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.DOUBLE,
    metrics: {
      Room_Nights: {
        subColumns: ['Select.', 'Compar.', '% Chg', 'Forecast'],
      },
      Revenue: {
        subColumns: ['Select.', 'Compar.', '% Chg', 'Forecast'],
      },
      ADR: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
      Cancellation_Count: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
    },
  },
  TXS_Cumulative: {
    headerType: VISUAL_HEADER_TYPES.GROUPED_DOUBLE,
    groupBy: 'Date',
  },
  TXS_Weekly: {
    headerType: VISUAL_HEADER_TYPES.GROUPED_DOUBLE,
    groupBy: 'Date Name',
  },
  TXS_Daily: {
    headerType: VISUAL_HEADER_TYPES.GROUPED_DOUBLE,
    groupBy: 'Date',
  },
  TVS_Daily: {
    headerType: VISUAL_HEADER_TYPES.DOUBLE_2,
    groupBy: 'Date',
  },
  TVS_Cumulative: {
    headerType: VISUAL_HEADER_TYPES.DOUBLE_2,
    groupBy: 'Date',
  },
  TVS_Percentage: {
    headerType: VISUAL_HEADER_TYPES.DOUBLE_2,
    groupBy: 'Date',
  },
  TVS_Weekly: {
    headerType: VISUAL_HEADER_TYPES.DOUBLE_2,
    groupBy: 'Date Name',
  },
  TVT_Percentage: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.DOUBLE,
    metrics: {
      Room_Nights: {
        subColumns: ['Selection', 'Comparison'],
      },
      Revenue: {
        subColumns: ['Selection', 'Comparison'],
      },
      ADR: {
        subColumns: ['Selection', 'Comparison'],
      },
    },
  },
  TVT_Cumulative: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.DOUBLE,
    metrics: {
      Room_Nights: {
        subColumns: ['Selection', 'Comparison', '% Chg', 'Forecast'],
      },
      Revenue: {
        subColumns: ['Selection', 'Comparison', '% Chg', 'Forecast'],
      },
      Cancellation_Count: {
        subColumns: ['Selection', 'Comparison', '% Chg'],
      },
    },
  },
  TVT_Weekly: {
    groupBy: 'Date Name',
    headerType: VISUAL_HEADER_TYPES.DOUBLE,
    metrics: {
      Room_Nights: {
        subColumns: ['Select.', 'Compar.', '% Chg', 'Forecast'],
      },
      Revenue: {
        subColumns: ['Select.', 'Compar.', '% Chg', 'Forecast'],
      },
      ADR: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
      ALOS: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
      Lead_Time: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
      Cancellation_Count: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
    },
  },
  TVT_Daily: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.DOUBLE,
    metrics: {
      Room_Nights: {
        subColumns: ['Select.', 'Compar.', '% Chg', 'Forecast'],
      },
      Revenue: {
        subColumns: ['Select.', 'Compar.', '% Chg', 'Forecast'],
      },
      ADR: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
      ALOS: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
      Lead_Time: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
      Cancellation_Count: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
    },
  },
  TVH_Normalized: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.DOUBLE,
    metrics: {
      Room_Nights: {
        subColumns: ['A Actls', 'B Actls', '% Chg', 'A Fcsts', 'B Fcsts'],
      },
      Revenue: {
        subColumns: ['A Actls', 'B Actls', '% Chg', 'A Fcsts', 'B Fcsts'],
      },
      ADR: {
        subColumns: ['A Actls', 'B Actls', '% Chg'],
      },
      ALOS: {
        subColumns: ['A Actls', 'B Actls', '% Chg'],
      },
      Lead_Time: {
        subColumns: ['A Actls', 'B Actls', '% Chg'],
      },
      Cancellation_Count: {
        subColumns: ['A Actls', 'B Actls', '% Chg'],
      },
    },
  },
  TVH_Daily: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.DOUBLE,
    metrics: {
      Room_Nights: {
        subColumns: ['A Actls', 'B Actls', '% Chg', 'A Fcsts', 'B Fcsts'],
      },
      Revenue: {
        subColumns: ['A Actls', 'B Actls', '% Chg', 'A Fcsts', 'B Fcsts'],
      },
      ADR: {
        subColumns: ['A Actls', 'B Actls', '% Chg'],
      },
      ALOS: {
        subColumns: ['A Actls', 'B Actls', '% Chg'],
      },
      Lead_Time: {
        subColumns: ['A Actls', 'B Actls', '% Chg'],
      },
      Cancellation_Count: {
        subColumns: ['A Actls', 'B Actls', '% Chg'],
      },
    },
  },
  TVH_Cumulative: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.DOUBLE,
    metrics: {
      Room_Nights: {
        subColumns: ['A Actls', 'B Actls', '% Chg', 'A Fcsts', 'B Fcsts'],
      },
      Revenue: {
        subColumns: ['A Actls', 'B Actls', '% Chg', 'A Fcsts', 'B Fcsts'],
      },
      Cancellation_Count: {
        subColumns: ['A Actls', 'B Actls', '% Chg'],
      },
    },
  },
  TVH_Weekly: {
    groupBy: 'Date name',
    headerType: VISUAL_HEADER_TYPES.DOUBLE,
    metrics: {
      Room_Nights: {
        subColumns: ['A Actls', 'B Actls', '% Chg', 'A Fcsts', 'B Fcsts'],
      },
      Revenue: {
        subColumns: ['A Actls', 'B Actls', '% Chg', 'A Fcsts', 'B Fcsts'],
      },
      ADR: {
        subColumns: ['A Actls', 'B Actls', '% Chg'],
      },
      ALOS: {
        subColumns: ['A Actls', 'B Actls', '% Chg'],
      },
      Lead_Time: {
        subColumns: ['A Actls', 'B Actls', '% Chg'],
      },
      Cancellation_Count: {
        subColumns: ['A Actls', 'B Actls', '% Chg'],
      },
    },
  },
  TVH_Percentage: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.DOUBLE,
    metrics: {
      Room_Nights: {
        subColumns: ['A Actls', 'B Actls'],
      },
      Revenue: {
        subColumns: ['A Actls', 'B Actls'],
      },
      ADR: {
        subColumns: ['A Actls', 'B Actls'],
      },
    },
  },
  CMATT_Daily: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.DOUBLE,
    transformColumns: true,
    metrics: {
      Room_Nights: {
        subColumns: ['metrics_spot_MA', 'Comparison'],
      },
      Revenue: {
        subColumns: ['metrics_spot_MA', 'Comparison'],
      },
      ADR: {
        subColumns: ['metrics_spot_MA', 'Comparison'],
      },
    },
  },
  CMATS_Daily: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.DOUBLE_2,
  },
  CMATH_Daily: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.DOUBLE,
    metrics: {
      Room_Nights: {
        subColumns: ['A Actls', 'B Actls'],
      },
      Revenue: {
        subColumns: ['A Actls', 'B Actls'],
      },
      ADR: {
        subColumns: ['A Actls', 'B Actls'],
      },
    },
  },
  //
  TXH_Daily: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.GROUPED_DOUBLE,
    metrics: {
      Room_Nights: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
      Revenue: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
      ADR: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
      ALOS: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
      Lead_Time: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
      Cancellation_Count: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
    },
  },
  TXH_Weekly: {
    groupBy: 'Day Name',
    headerType: VISUAL_HEADER_TYPES.GROUPED_DOUBLE,
    metrics: {
      Room_Nights: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
      Revenue: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
      ADR: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
      ALOS: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
      Lead_Time: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
      Cancellation_Count: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
    },
  },
  TXH_Cumulative: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.GROUPED_DOUBLE,
    metrics: {
      Room_Nights: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
      Revenue: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
      Cancellation_Count: {
        subColumns: ['Select.', 'Compar.', '% Chg'],
      },
    },
  },
  PHS_Daily: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.GROUPED_DOUBLE,
  },
  PHS_Lag_Aligned: {
    groupBy: 'lags',
    headerType: VISUAL_HEADER_TYPES.GROUPED_DOUBLE,
  },
  PHS_Cumulative: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.GROUPED_DOUBLE,
  },
  PHS_Cumulative_Lag_Aligned: {
    groupBy: 'lags',
    headerType: VISUAL_HEADER_TYPES.GROUPED_DOUBLE,
  },
  PTS_Daily: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.GROUPED_DOUBLE,
  },
  PTS_Lag_Aligned: {
    groupBy: 'lags',
    headerType: VISUAL_HEADER_TYPES.GROUPED_DOUBLE,
  },
  PTS_Cumulative: {
    groupBy: 'Date',
    headerType: VISUAL_HEADER_TYPES.GROUPED_DOUBLE,
  },
  PTS_Cumulative_Lag_Aligned: {
    groupBy: 'lags',
    headerType: VISUAL_HEADER_TYPES.GROUPED_DOUBLE,
  },
  //
  Summary_1f564914fc738bbfaf58: {
    headerType: VISUAL_HEADER_TYPES.SINGLE_2,
    title: 'Summary Tabular',
    groupBy: '   ',
    metrics: [
      '   ',
      'Selection',
      'Comparison',
      '% Chg',
      'Selection YTD',
      'Previous Year YTD',
      '% Chg',
    ],
    order: 0,
  },
  Summary_edfb7ec20176cf935522: {
    headerType: VISUAL_HEADER_TYPES.SINGLE_2,
    title: 'Summary Bar Chart Data',
    groupBy: 'Month Year',
    metrics: [
      'Month Year',
      'Total Room Nights',
      'Comp. Room Nights',
      'Total Revenue',
      'Comp. Total Revenue',
    ],
    order: 1,
  },
  Summary_a42e9a818c8190778011: {
    headerType: VISUAL_HEADER_TYPES.SINGLE_2,
    title: 'Summary RC Mix',
    groupBy: 'Total Room Nights',
    metrics: ['Total Room Nights', 'Value'],
    order: 2,
  },
  Summary_237f73d65ba78ea8322d: {
    headerType: VISUAL_HEADER_TYPES.SINGLE_2,
    title: 'Summary Channel Mix',
    groupBy: 'Value',
    metrics: ['channel', 'Total Room Nights'],
    order: 3,
  },
  //
  Summary_Hotel_1a740f94120920431e68: {
    headerType: VISUAL_HEADER_TYPES.SINGLE_2,
    title: 'Summary Tabular',
    groupBy: '   ',
    metrics: [
      '   ',
      'Selection',
      'Comparison',
      '% Chg',
      'Selection YTD',
      'Previous Year YTD',
      '% Chg',
    ],
    order: 0,
  },
  Summary_Hotel_1326c34fc61c56345da2: {
    headerType: VISUAL_HEADER_TYPES.SINGLE_2,
    title: 'Summary Bar Chart Data',
    groupBy: 'Month Year',
    metrics: [
      'Month Year',
      'Comp. Room Nights',
      'Total Room Nights',
      'Total Revenue',
      'Comp. Total Revenue',
    ],
    order: 1,
  },
  Summary_Hotel_8e9d1a68902008cb2c5c: {
    headerType: VISUAL_HEADER_TYPES.SINGLE_2,
    title: 'Summary Channel Mix',
    groupBy: 'Total Room Nights',
    metrics: ['Total Room Nights', 'channel'],
    order: 2,
  },
  Summary_Hotel_20622362a93d0cdc7d6e: {
    headerType: VISUAL_HEADER_TYPES.SINGLE_2,
    title: 'Summary Rate Category Mix',
    groupBy: 'Value',
    metrics: ['Value', 'Total Room Nights'],
    order: 3,
  },
  // Rate Category Visuals
  Rate_Category_667fcf26066bb41d9bb1: {
    headerType: VISUAL_HEADER_TYPES.SINGLE_2,
    title: 'Rate Categories',
    groupBy: 'Rate Categories',
    metrics: ['Rate Category', 'CP RN', '% Chg', 'CP Rev', '% Chg', 'ADR', 'LoS'],
    order: 4,
  },
  Rate_Category_7efe7187929479673ece: {
    headerType: VISUAL_HEADER_TYPES.SINGLE_2,
    title: 'Channels',
    groupBy: 'Channel',
    metrics: ['Channel', 'CP RN', '% Chg', 'CP Rev', '% Chg', 'ADR', 'ALT'],
    order: 5,
  },
  Rate_Category_d6d19dd9d944de8c5adf: {
    headerType: VISUAL_HEADER_TYPES.SINGLE_2,
    title: 'Top 10 Rate Plans - Room Nights',
    groupBy: 'Rate Plan',
    metrics: ['Rate Plan', 'CP RN', '% of', 'CP Rev', '% of', 'ADR', 'Avg LoS'],
    order: 6,
  },
  Rate_Category_ef292b9fbb973a466691: {
    headerType: VISUAL_HEADER_TYPES.SINGLE_2,
    title: 'Top 10 Travel Agency',
    groupBy: 'Agency Name',
    metrics: ['Agency Name', 'CP RN', 'LP RN', 'Var.', 'CP Rev', 'LP Rev', '% Chg'],
    order: 7,
  },
  Rate_Category_8f5a3bbb333ac1dd0194: {
    headerType: VISUAL_HEADER_TYPES.SINGLE_2,
    title: 'Top Growth Rate Plans-RN',
    groupBy: 'Rate Plan',
    metrics: ['Rate Plan', 'CP RN', 'LP RN', 'Var.', 'CP Rev', 'LP Rev', '% Chg'],
    order: 8,
  },
  Rate_Category_b5bb4d2cf834d97584d8: {
    headerType: VISUAL_HEADER_TYPES.SINGLE_2,
    title: 'Lost Production RP-RN',
    groupBy: 'Rate Plan',
    metrics: ['Rate Plan', 'CP RN', 'LP RN', 'Var.', 'CP Rev', 'LP Rev', '% Chg'],
    order: 9,
  },
  // Hotel Rate Category Visuals
  Rate_Category_Hotel_3d400e5a3aa9ad0e2076: {
    headerType: VISUAL_HEADER_TYPES.SINGLE_2,
    title: 'Rate Categories',
    groupBy: 'Rate Category',
    metrics: ['Rate Category', 'CP RN', '% Chg', 'CP Rev', '% Chg', 'ADR', 'LoS'],
    order: 4,
  },
  Rate_Category_Hotel_bc25889300e6ec272e3a: {
    headerType: VISUAL_HEADER_TYPES.SINGLE_2,
    title: 'Channels',
    groupBy: 'Channel',
    metrics: ['Channel', 'CP RN', '% Chg', 'CP Rev', '% Chg', 'ADR', 'ALT'],
    order: 5,
  },
  Rate_Category_Hotel_e51f412be406713ea5a8: {
    headerType: VISUAL_HEADER_TYPES.SINGLE_2,
    title: 'Top 10 Rate Plans-Room Nights',
    groupBy: 'Rate Plan',
    metrics: ['Rate Plan', 'CP RN', '% of', 'CP Rev', '% of', 'ADR', 'Avg LoS'],
    order: 6,
  },
  Rate_Category_Hotel_ec88a2a57dd626663231: {
    headerType: VISUAL_HEADER_TYPES.SINGLE_2,
    title: 'Top 10 Travel Agency',
    groupBy: 'Agency Name',
    metrics: ['Agency Name', 'CP RN', 'LP RN', 'Var.', 'CP Rev', 'LP Rev', '% Chg'],
    order: 7,
  },
  Rate_Category_Hotel_92c80e6780c4c32c90e0: {
    headerType: VISUAL_HEADER_TYPES.SINGLE_2,
    title: 'Top Growth Rate Plans-RN',
    groupBy: 'Rate Category',
    metrics: ['Rate Plan', 'CP RN', 'LP RN', 'Var.', 'CP Rev', 'LP Rev', '% Chg'],
    order: 8,
  },
  Rate_Category_Hotel_3f8ec5536984d182b280: {
    headerType: VISUAL_HEADER_TYPES.SINGLE_2,
    title: 'Lost Rate Categories-RN',
    groupBy: 'Rate Category',
    metrics: ['Rate Plan', 'CP RN', 'LP RN', 'Var.', 'CP Rev', 'LP Rev', '% Chg'],
    order: 9,
  },
  //
  Room_Night_Pace_Channel: {
    headerType: VISUAL_HEADER_TYPES.SINGLE,
    title: 'Room Night Pace by Channel',
    groupBy: 'Channel',
    order: 10,
  },
};

export default mapper;
